fragment GenericEntryCardAsset on AssetInterface {
    url
    w232: url @transform(width: 232, format: "webp")
    w251: url @transform(width: 251, format: "webp")
    w464: url @transform(width: 464, format: "webp")
    w710: url @transform(width: 696, format: "webp")
    w362: url @transform(width: 362, format: "webp")
    w355: url @transform(width: 355, format: "webp")

    w232_avif: url @transform(width: 232, format: "avif")
    w251_avif: url @transform(width: 251, format: "avif")
    w464_avif: url @transform(width: 464, format: "avif")
    w710_avif: url @transform(width: 696, format: "avif")
    w362_avif: url @transform(width: 362, format: "avif")
    w355_avif: url @transform(width: 355, format: "avif")
}
